import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-screen min-w-screen bg-orange-4" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red flex items-center justify-center p-2 text-white font-bold"
}
const _hoisted_3 = {
  key: 4,
  class: "h-full w-full lg:flex"
}
const _hoisted_4 = { class: "px-xs lg:px-ms lg:pl-0 w-full lg:overflow-scroll bg-orange-4" }

import { onMounted, ref } from "vue";
import AuthenticationView from "./modules/Authentication/views/AuthenticationView.vue";
import CreateProfileView from "./modules/Authentication/views/CreateProfileView.vue";
import SelectCareProviderGroupView from "./modules/Authentication/views/SelectCareProviderGroupView.vue";
import { supabase } from "@/helpers/supabase";
import { Session } from "@supabase/supabase-js";
import { computed } from "vue";
import NoCareProviderGroupCard from "@/modules/Authentication/components/NoCareProviderGroupCard.vue";
import LoadingCard from "@/components/LoadingCard.vue";
import InputPasswordView from "@/modules/Authentication/views/InputPasswordView.vue";
import { usePublicStore } from "@/store/publicStore";
import { useAccountStore } from "@/store/accountStore";
import { useSessionStore } from "@/store/sessionStore";
import PrimaryNavigation from "@/components/PrimaryNavigation.vue";
import NotificationBubbles from "@/components/NotificationBubbles.vue";
import UpdateView from "./views/UpdateView.vue";
import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const env = ref(process.env.VUE_APP_ENV);

const session = ref<Session | null>();
const isLoading = ref<boolean>(false);

const publicStore = usePublicStore();
const accountStore = useAccountStore();
const sessionStore = useSessionStore();

const careProviderGroups = computed(() => accountStore.careProviderGroups);
const selectedCareProviderGroup = computed(
  () => sessionStore.selectedCareProviderGroup
);
const loadedCareProviderGroup = computed(
  () => sessionStore.isInitialLoadFinished
);
const keyPair = computed(() => sessionStore.keyPair);
const salt = computed(() => sessionStore.salt);

onMounted(() => {
  supabase.auth.getSession().then(({ data }) => {
    session.value = data.session;
    let userId = session.value?.user?.id;
    if (userId) {
      window._paq.push(["setUserId", userId]);
    }
    sessionStore.session = data.session;
    publicStore.loadPublicStore();
    if (data.session == null) return;
    accountStore
      .loadProfile()
      .then(() => {
        if (sessionStore.keyPair != null || sessionStore.password != null) {
          accountStore.loadCpgs().finally(() => {
            isLoading.value = false;
          });
        } else {
          isLoading.value = false;
        }
      })
      .catch(() => {
        isLoading.value = false;
      });
  });

  supabase.auth.onAuthStateChange(async (_change, _session) => {
    if (_change == "SIGNED_OUT" || _change == "TOKEN_REFRESHED") {
      location.reload();
      return;
    }

    if (session.value == null && _session != null) {
      isLoading.value = true;
      publicStore.loadPublicStore();
      session.value = _session;
      sessionStore.session = _session;
      let userId = session.value.user?.id;
      if (userId) {
        window._paq.push(["setUserId", userId]);
      }

      accountStore
        .loadProfile()
        .then(() => {
          if (sessionStore.keyPair != null || sessionStore.password != null) {
            accountStore.loadCpgs().finally(() => {
              isLoading.value = false;
            });
          } else {
            isLoading.value = false;
          }
        })
        .catch(() => {
          isLoading.value = false;
        });
    }
  });
});

// ====================================================== Core Update
const updateOutstanding = ref(true);
const loadingUpdateStatusFinished = ref(false);
watch(
  () => sessionStore.isInitialLoadFinished,
  (newValue) => {
    if (newValue) {
      let error = null;
      do {
        supabase
          .from("careProviderGroup")
          .select("updated")
          .single()
          .eq("id", sessionStore.selectedCareProviderGroup?.id)
          .then((result) => {
            if (!result.data.updated) {
              updateOutstanding.value = true;
            } else {
              updateOutstanding.value = false;
            }
            error = null;
          })
          .catch((e) => {
            error = e;
          })
          .finally(() => {
            loadingUpdateStatusFinished.value = true;
          });
      } while (error !== null);
    }
  }
);

async function updateFinished() {
  const result = await supabase
    .from("careProviderGroup")
    .update({ updated: true })
    .eq("id", sessionStore.selectedCareProviderGroup?.id);
  updateOutstanding.value = false;
}
// ====================================================== Core Update

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (env.value === 'dev' || env.value === 'test')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(env.value === "dev" ? "Dev Environment" : "Test Environment"), 1))
      : _createCommentVNode("", true),
    _createVNode(NotificationBubbles),
    (isLoading.value || (session.value && !_unref(accountStore).loadedProfile))
      ? (_openBlock(), _createBlock(LoadingCard, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(" Laden... ")
          ]),
          _: 1
        }))
      : (updateOutstanding.value && loadingUpdateStatusFinished.value)
        ? (_openBlock(), _createBlock(UpdateView, {
            key: 2,
            onUpdateFinished: updateFinished
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (session.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!salt.value || _unref(accountStore).lastName == '')
                    ? (_openBlock(), _createBlock(CreateProfileView, { key: 0 }))
                    : (keyPair.value == null)
                      ? (_openBlock(), _createBlock(InputPasswordView, { key: 1 }))
                      : (
            careProviderGroups.value?.length != null &&
            careProviderGroups.value?.length == 0
          )
                        ? (_openBlock(), _createBlock(NoCareProviderGroupCard, { key: 2 }))
                        : (selectedCareProviderGroup.value == null)
                          ? (_openBlock(), _createBlock(SelectCareProviderGroupView, { key: 3 }))
                          : (loadedCareProviderGroup.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(PrimaryNavigation, { selectedCareProviderGroup: selectedCareProviderGroup.value }, null, 8, ["selectedCareProviderGroup"]),
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_router_view, { class: "w-full pt-xs pl-0" })
                                ])
                              ]))
                            : (_openBlock(), _createBlock(LoadingCard, { key: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Die Daten Ihres Unternehmens werden heruntergeladen und mit ihrem Passwort entschlüsselt... ")
                                ]),
                                _: 1
                              }))
                ], 64))
              : (_openBlock(), _createBlock(AuthenticationView, { key: 1 }))
          ], 64))
  ]))
}
}

})